import { render, staticRenderFns } from "./BookingManagerNotifications.vue?vue&type=template&id=49e6c7c4"
import script from "./BookingManagerNotifications.vue?vue&type=script&lang=js"
export * from "./BookingManagerNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports